(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Add to cart: show count + redirect to cart
  document.addEventListener('DOMContentLoaded', () => {
    const cartCounts = {};

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cpc-atc-btn');
      if (!btn) return;

      const variantId = btn.dataset.variantId || 'unknown';
      cartCounts[variantId] = (cartCounts[variantId] || 0) + 1;
      const count = cartCounts[variantId];

      const btnText = btn.querySelector('.btn-text');
      if (btnText) {
        btnText.textContent = `Added (${count})`;
      }

      setTimeout(() => {
        window.location.href = 'https://www.bohotales.com/cart';
      }, 800);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
